import React from 'react';

import CategorySummaryTotals from './CategorySummaryTotals';
import CategorySummaryTopFive from './CategorySummaryTopFive';
import { InfoIconToolTip } from '../../UI/InfoIconToolTip/InfoIconToolTip';

import Styles from './styles.module.scss';
import { PermissionsUI } from '../../Permissions/PermissionsUI';
import { ReactComponent as CatIcon } from '../../../assets/images/total-cat-perm.svg';

export interface ICategorySummaryWidget {
    title: JSX.Element | string;
    totalValue: string;
    selection: string;
    onCategoryChange: (value: string) => void;
    listTitle: string;
    loading?: boolean;
    topFiveItems: {
        id: number;
        name: string;
        category: string;
        total: string;
        revenue: string;
        photoUrl?: string;
    }[];
    categories: { id: string; name: string }[];
    allVenues?: boolean;
    hasPermission?: boolean;
}

const CategorySummaryWidget = (props: ICategorySummaryWidget) => {
    const { hasPermission = true } = props;
    return (
        <div className={Styles.Wrapper}>
            <div className={Styles.Header}>
                <span>{props.title}</span>
                {hasPermission && (
                    <InfoIconToolTip
                        infoMessage={
                            props.allVenues
                                ? 'misc.Overview.CategorySummaryTooltip'
                                : 'misc.Analytics.CategorySummaryTooltip'
                        }
                    />
                )}
            </div>
            <div className={Styles.Content}>
                {hasPermission ? (
                    <>
                        <div className={Styles.TotalsWrapper}>
                            <CategorySummaryTotals
                                totalValue={props.totalValue}
                                selection={props.selection}
                                onCategoryChange={props.onCategoryChange}
                                loading={props.loading}
                                categories={props.categories}
                            />
                        </div>

                        <CategorySummaryTopFive
                            title={props.listTitle}
                            items={props.topFiveItems}
                            loading={props.loading}
                            allVenues={props.allVenues}
                        />
                    </>
                ) : (
                    <PermissionsUI icon={<CatIcon />} />
                )}
            </div>
        </div>
    );
};

export default CategorySummaryWidget;
